import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingMaiImageAiGeneratorConfig } from '@/data/landingConfig/landingMaiImageAiGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_MaiImageAiGenerator } from './schemaObject';

interface Props {}
const MaiImageAiGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_MaiImageAiGenerator} />
			<LandingTemplate
				data={landingMaiImageAiGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageGeneratorV2()}
			/>
		</>
	);
};

export default MaiImageAiGenerator;
